import { Component, EventEmitter, Input, Output } from '@angular/core';

// Full-screen overlay showing a single image at its full extent.
// Rendered only while `src` is set; clicking anywhere dismisses it.
@Component({
	selector: 'app-image-preview',
	templateUrl: './image-preview.component.html',
})
export class ImagePreviewComponent {
	@Input() src: string | null = null;

	@Output() closed = new EventEmitter<void>();
}
